// Wallet Persistence Utilities
const ACTIVE_WALLET_KEY = 'safepump_active_wallet';

export const walletPersistence = {
  // Save active wallet to localStorage
  save: (wallet) => {
    try {
      if (wallet) {
        const walletData = {
          id: wallet.id,
          name: wallet.name,
          wallet_address: wallet.wallet_address,
          wallet_type: wallet.wallet_type,
          is_active: wallet.is_active,
          created_at: wallet.created_at,
          savedAt: new Date().toISOString()
        };
        localStorage.setItem(ACTIVE_WALLET_KEY, JSON.stringify(walletData));
        console.log('💾 Wallet saved to localStorage:', walletData.name, `(ID: ${walletData.id})`);
        return true;
      } else {
        localStorage.removeItem(ACTIVE_WALLET_KEY);
        console.log('🗑️ Active wallet cleared from localStorage');
        return true;
      }
    } catch (error) {
      console.error('❌ Failed to save wallet to localStorage:', error);
      return false;
    }
  },

  // Load active wallet from localStorage
  load: () => {
    try {
      const stored = localStorage.getItem(ACTIVE_WALLET_KEY);
      if (stored) {
        const walletData = JSON.parse(stored);
        console.log('📂 Wallet loaded from localStorage:', walletData.name, `(ID: ${walletData.id})`);
        console.log('📅 Saved at:', walletData.savedAt);
        return walletData;
      } else {
        console.log('📭 No wallet found in localStorage');
        return null;
      }
    } catch (error) {
      console.error('❌ Failed to load wallet from localStorage:', error);
      return null;
    }
  },

  // Check if wallet exists in localStorage
  exists: () => {
    try {
      return localStorage.getItem(ACTIVE_WALLET_KEY) !== null;
    } catch (error) {
      return false;
    }
  },

  // Clear wallet from localStorage
  clear: () => {
    try {
      localStorage.removeItem(ACTIVE_WALLET_KEY);
      console.log('🧹 Wallet persistence cleared');
      return true;
    } catch (error) {
      console.error('❌ Failed to clear wallet persistence:', error);
      return false;
    }
  },

  // Get debug info
  getDebugInfo: () => {
    try {
      const stored = localStorage.getItem(ACTIVE_WALLET_KEY);
      return {
        hasStoredWallet: !!stored,
        storedWallet: stored ? JSON.parse(stored) : null,
        storageSize: stored ? stored.length : 0,
        lastSaved: stored ? JSON.parse(stored).savedAt : null
      };
    } catch (error) {
      return {
        hasStoredWallet: false,
        storedWallet: null,
        storageSize: 0,
        lastSaved: null,
        error: error.message
      };
    }
  }
};

// Export individual functions for convenience
export const saveActiveWallet = walletPersistence.save;
export const loadActiveWallet = walletPersistence.load;
export const clearActiveWallet = walletPersistence.clear;
export const walletExists = walletPersistence.exists;

export default walletPersistence;